import { combineReducers } from 'redux'
import { reducer as allUniteRegionales } from './getAllUniteRegionales'
import { reducer as disabledUniteRegionales } from './getDisabledUniteRegionales'
import { reducer as addUniteRegionale } from './addUniteRegionale'
import { reducer as editUniteRegionale } from './editUniteRegionale'
import { reducer as deleteUniteRegionale } from './deleteUniteRegionale'

export default combineReducers({
    allUniteRegionales,
    disabledUniteRegionales,
    addUniteRegionale,
    editUniteRegionale,
    deleteUniteRegionale,
})
